import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const IconCategoryEntertainment = (props) => (<Svg width={props.width} height={props.height} fill="none" {...props}>
    <Path d="m21.682 16.09-1.09-7.66A3.995 3.995 0 0 0 16.632 5h-9.06c-1.99 0-3.68 1.46-3.96 3.43l-1.09 7.66a2.545 2.545 0 0 0 4.32 2.16L9.102 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91ZM11.102 11h-2v2h-1v-2h-2v-1h2V8h1v2h2v1Zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z" fill={props.fill}/>
  </Svg>);
export default IconCategoryEntertainment;
